import React from 'react'
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg'
import styled, { useTheme } from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { svgIdentifier } from 'ui/svg/utils'

const ShowSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
}) => {
  const {
    colors: { primary, secondary },
  } = useTheme()
  const { id: gradientId, fill: gradientFill } = svgIdentifier()

  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      testID={testID}
      accessibilityLabel={accessibilityLabel}>
      <Defs>
        <LinearGradient id={gradientId} x1="13.556%" x2="86.444%" y1="0%" y2="100%">
          <Stop offset="0%" stopColor={color ?? primary} />
          <Stop offset="100%" stopColor={color2 ?? color ?? secondary} />
        </LinearGradient>
      </Defs>
      <Path
        fill={gradientFill}
        clipRule="evenodd"
        fillRule="evenodd"
        d="M21.9222 2.16471L26.1364 3.35496C26.6568 3.50194 26.9662 4.03607 26.8349 4.5608C26.4011 6.29366 27.485 8.16636 29.3193 8.68199C31.1409 9.19406 32.9091 8.16857 33.3352 6.46607C33.4009 6.20365 33.57 5.97902 33.804 5.84339C34.038 5.70777 34.3169 5.67271 34.5772 5.74622L38.7938 6.93714C41.0298 7.57168 42.4426 9.87314 41.8739 12.1388L35.9463 35.7488C35.8118 36.2847 35.2684 36.61 34.7327 36.4754C34.1969 36.3409 33.8717 35.7973 34.0062 35.2614L39.9338 11.6515C40.2261 10.4869 39.4964 9.21672 38.2483 8.86229L34.9264 7.92404C33.857 10.1589 31.2814 11.312 28.7781 10.6083C26.2692 9.90304 24.6017 7.53832 24.7465 5.04161L21.3763 4.08973C20.1491 3.74149 18.9602 4.44042 18.6742 5.57074L18.6739 5.57178L17.7233 9.37338C17.5892 9.90942 17.0462 10.2353 16.5103 10.1012C15.9744 9.96709 15.6487 9.42384 15.7827 8.8878L16.7345 5.08177C17.31 2.8026 19.6655 1.52471 21.9222 2.16471ZM6 16.153C6 13.8035 7.94115 11.944 10.2744 11.944H14.6299C15.1823 11.944 15.6301 12.392 15.6301 12.9445C15.6301 14.7342 17.1159 16.2221 18.9955 16.2221C20.8751 16.2221 22.3609 14.7342 22.3609 12.9445C22.3609 12.392 22.8087 11.944 23.3611 11.944H27.7267C30.0611 11.944 31.9978 13.8034 32.011 16.1474L32.011 16.153L32.011 41.791C32.011 44.1406 30.0699 46 27.7367 46H23.3711C22.8187 46 22.3709 45.5521 22.3709 44.9995C22.3709 43.2098 20.8851 41.722 19.0055 41.722C17.1259 41.722 15.6401 43.2098 15.6401 44.9995C15.6401 45.5521 15.1923 46 14.6399 46H10.2744C7.92705 46 6 44.1265 6 41.791V16.153ZM10.2744 13.945C9.00295 13.945 8.00033 14.951 8.00033 16.153V41.791C8.00033 42.9869 8.99702 43.999 10.2744 43.999H13.7357C14.212 41.5512 16.4031 39.721 19.0055 39.721C21.608 39.721 23.799 41.5512 24.2753 43.999H27.7367C29.0081 43.999 30.0107 42.993 30.0107 41.791V16.1562C30.0025 14.9498 28.996 13.945 27.7267 13.945H24.2653C23.789 16.3928 21.5979 18.223 18.9955 18.223C16.393 18.223 14.202 16.3928 13.7257 13.945H10.2744ZM12.9567 23.6985C12.4043 23.6985 11.9565 24.1462 11.9565 24.6985C11.9565 25.2508 12.4043 25.6985 12.9567 25.6985H25.0321C25.5845 25.6985 26.0323 25.2508 26.0323 24.6985C26.0323 24.1462 25.5845 23.6985 25.0321 23.6985H12.9567Z"
      />
    </AccessibleSvg>
  )
}

export const Show = styled(ShowSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.colors.black,
  size: size ?? theme.icons.sizes.standard,
}))``
